/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalVote
 */
export interface ProposalVote {
    /**
     * 
     * @type {number}
     * @memberof ProposalVote
     */
    proposalId: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalVote
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalVote
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalVote
     */
    icon: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalVote
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalVote
     */
    vote: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalVote
     */
    amount: string;
    /**
     * 
     * @type {number}
     * @memberof ProposalVote
     */
    percent: number;
}

export function ProposalVoteFromJSON(json: any): ProposalVote {
    return ProposalVoteFromJSONTyped(json, false);
}

export function ProposalVoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalVote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': json['proposalId'],
        'title': json['title'],
        'name': json['name'],
        'icon': json['icon'],
        'address': json['address'],
        'vote': json['vote'],
        'amount': json['amount'],
        'percent': json['percent'],
    };
}

export function ProposalVoteToJSON(value?: ProposalVote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'proposalId': value.proposalId,
        'title': value.title,
        'name': value.name,
        'icon': value.icon,
        'address': value.address,
        'vote': value.vote,
        'amount': value.amount,
        'percent': value.percent,
    };
}


